import {t} from '../common/getTranslations';
import {BadgeType} from '../graphql/generated/types';
import {BADGE_TYPE_ALT_TEXT_MAP} from './constant';

export function getItemAltText({
  title,
  badgeList = [],
  statusBadge,
  ageGradeBadge,
  // 카드뷰, 포스터뷰, 노말리스트 row2
  subtitleList = [],
  // 노말리스트뷰 하단 정보(row3)
  normalListViewMetaList = [],
  // 노말리스트뷰 운영 정보(row4; ex. 혜택정보 문구, 무료 편수 정보, 구매 일자 등)
  operationalTextList = [],
  // 노말리스트뷰 row5에 들어가는 티켓 관련 문구
  ticketExpiredText,
  rank,
  rankingVariation,
  isSet = false,
}: {
  title: string;
  badgeList?: BadgeType[];
  statusBadge?: BadgeType;
  ageGradeBadge?: BadgeType;
  subtitleList?: string[];
  normalListViewMetaList?: string[];
  operationalTextList?: string[];
  ticketExpiredText?: string;
  rank?: string;
  rankingVariation?: number;
  isSet?: boolean;
}): string {
  const altTextList: string[] = [];

  // 배너의 경우 서버에서 alt_text를 내려주므로 작품/세트상품에만 사용됨.
  altTextList.push(t(isSet ? 'common_accessibility_set' : 'common_content'));
  altTextList.push(title);
  // BM 뱃지
  if (badgeList.length > 0) {
    badgeList.map(badge => {
      altTextList.push(BADGE_TYPE_ALT_TEXT_MAP[badge]);
    });
  }
  // 업데이트 뱃지
  if (statusBadge) {
    altTextList.push(BADGE_TYPE_ALT_TEXT_MAP[statusBadge]);
  }
  // 연령 뱃지
  if (ageGradeBadge) {
    altTextList.push(BADGE_TYPE_ALT_TEXT_MAP[ageGradeBadge]);
  }

  // 작품 정보
  if (subtitleList.length > 0) {
    subtitleList.map(subtitle => {
      altTextList.push(subtitle);
    });
  }
  if (normalListViewMetaList.length > 0) {
    normalListViewMetaList.map(meta => {
      altTextList.push(meta);
    });
  }
  if (operationalTextList.length > 0) {
    operationalTextList.map(text => {
      altTextList.push(text);
    });
  }
  if (ticketExpiredText) {
    altTextList.push(ticketExpiredText);
  }

  // 랭킹 정보
  if (rank) {
    if (rankingVariation === undefined) {
      altTextList.push(
        t('landing_accessibility_rank_new', {
          values: {
            value: rank,
          },
        })
      );
    } else if (rankingVariation === 0) {
      altTextList.push(
        t('landing_accessibility_rank_stay', {
          values: {
            value: rank,
          },
        })
      );
    } else if (rankingVariation > 0) {
      altTextList.push(
        t('landing_accessibility_rank_up', {
          values: {
            value: rank,
            step: rankingVariation,
          },
        })
      );
    } else if (rankingVariation < 0) {
      altTextList.push(
        t('landing_accessibility_rank_down', {
          values: {
            value: rank,
            step: rankingVariation,
          },
        })
      );
    }
  }

  altTextList.push(t('common_accessibility_only_button'));

  return altTextList.join(', ');
}

/**
 * ex. 작품, {작품명}, {BM뱃지}, {업데이트뱃지}, {연령 뱃지}, 조회수 {}, 버튼
 * 작품, {작품명}, {BM뱃지}, {업데이트 뱃지}, {연령뱃지}, {랭킹 정보}, 버튼
 * 작품, {작품명}, {BM뱃지}, {연령 뱃지}, {랭킹 정보}, 버튼
 */
